module.exports = __webpack_public_path__ + "static/img/byconcept-04.9cea527.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/byconcept-04.webp
// module id = 70
// module chunks = 0